module.exports = __webpack_public_path__ + "assets/img/2004.ca13fad9.png";